// extracted by mini-css-extract-plugin
module.exports = {"socialContainer":"social_socialContainer__2nNbI","imgicon":"social_imgicon__1GY4q"};